import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";

const schema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
});

export const Route = createFileRoute("/auth")({
  validateSearch: (search) => {
    return schema.parse(search);
  },
  component: AuthLayout,
});

function AuthLayout() {
  return <Outlet />;
}
